import store from '@/store'
import moment from 'moment'

export default {
  onEnter (to, from, next) {
    let queryParams = {}
    store.dispatch('tasks/query', {
      ...to.query,
      ...queryParams
    })
      .then(({data}) => {
        next()
      }).catch(error => {
        next(error)
      })
  },
  onQueryToday (to, from, next) {
    let queryParams = {}
    queryParams['filters[whereBetween][dueDate]'] = [moment().format('YYYY-MM-DD'), moment().add(1, 'day').format('YYYY-MM-DD')]
    store.dispatch('tasks/query', {
      ...to.query,
      ...queryParams
    })
      .then(({data}) => {
        next()
      })
      .catch(error => {
        next(error)
      })
  }
}



// WEBPACK FOOTER //
// ./src/guards/tasks.guards.js